import React from 'react';
import CookieHelp from '../../../tool/CookieHelp';
import styles from './OtherSysNavPage.less';
import { Result } from 'antd';

export default function OtherSysNavPage() {
	let userInfo = CookieHelp.getUserInfo();
	let originUrl = window.encodeURIComponent(window.location.href);

	console.log('process', process.env);
	let navConfig =
		location.href.includes('dev.fwgcloud.com')
			? {
				wikiPage: 'https://wiki-admin-dev.fwgcloud.com:2443',
				// coursePage: 'https://study-admin-dev.fwgcloud.com',
				nodeBBPage: 'https://community-dev.fwgcloud.com/admin',
			}
			: {
				wikiPage: 'https://wiki-admin.cyberxharness.com:2443',
				// coursePage: 'https://study-admin.cyberxharness.com',
				nodeBBPage: 'https://community.cyberxharness.com/admin',
			};

	return (
		<div className={styles.mainPage}>
			{!userInfo?.info.wikiAccount && !userInfo?.info.courseAccount && !userInfo?.info.nodeBBAccount ? <Result status="403" title="请先在账号管理中配置当前账号的关联后台" subTitle="您没有任何关联后台的访问权限" /> : null}
			<div className={styles.navContainer}>
				<div className={styles.navContainerItem}>
					{userInfo?.info.wikiAccount ? (
						<div
							className={styles.navItem}
							onClick={() => {
								window.open(`${navConfig.wikiPage}?from=${originUrl}`, '_blank');
							}}
						>
							<div className={styles.navLogo} style={{ backgroundImage: `url(${require('../../../images/otherSys/wikiNav.png')})` }}></div>
							访问文档管理后台
						</div>
					) : null}
					{/* {userInfo?.info.courseAccount ? (
						<div
							className={styles.navItem}
							onClick={() => {
								window.open(`${navConfig.coursePage}?from=${originUrl}`, '_blank');
							}}
						>
							<div className={styles.navLogo} style={{ backgroundImage: `url(${require('../../../images/otherSys/courseNav.png')})` }}></div>
							访问课程管理后台
						</div>
					) : null} */}
					{userInfo?.info.nodeBBAccount ? (
						<div
							className={styles.navItem}
							onClick={() => {
								window.open(`${navConfig.nodeBBPage}?from=${originUrl}`, '_blank');
							}}
						>
							<div className={styles.navLogo} style={{ backgroundImage: `url(${require('../../../images/otherSys/nodeBBNav.png')})` }}></div>
							访问社区管理后台
						</div>
					) : null}
				</div>
			</div>
		</div >
	);
}
